/**
 * Hyperbeat Vault-Infra read fragments (HyperEVM, chain 999).
 *
 * The core Hyperbeat vaults (hbUSDT, hbUSDC, lstHYPE, liquidHYPE) are NOT
 * ERC-4626 — the share token is a bare upgradeable ERC-20 (a renamed Midas
 * mToken) and every 4626 view reverts. The live periphery is Hyperbeat's
 * own audited Vault-Infra (Nethermind + Certora,
 * github.com/0xhyperbeat/Audits), one triplet per vault:
 *
 *  - **Pricer** — `getRate()` at `decimals()` (8 on all four live vaults):
 *    underlying-per-share, the only share-price source. NB the Midas
 *    periphery the docs still list is RETIRED — its deposit/redemption
 *    vaults revert `Pausable: paused` and its NAV aggregators last updated
 *    2025-12-22.
 *  - **Depositor** — `deposit(tokenIn, receiver, amount, referrerId)`;
 *    `isPaused()` gates it.
 *  - **WithdrawalQueue** — `instantWithdraw(user, shares)` at
 *    `instantWithdrawalFee()` (base 10 000 ⇒ the value IS bps), capped by
 *    the queue's own `baseAsset` balance (ops top it up periodically — 0 is
 *    a normal reading); or `createWithdrawalRequest(...)`, processed by ops
 *    within the docs' 1–3 days and paid out automatically (no claim step).
 */

export const HyperbeatPricerReadAbi = [
  {
    inputs: [],
    name: 'getRate',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'decimals',
    outputs: [{ internalType: 'uint8', name: '', type: 'uint8' }],
    stateMutability: 'view',
    type: 'function',
  },
] as const

export const HyperbeatQueueReadAbi = [
  {
    inputs: [],
    name: 'instantWithdrawalFee',
    outputs: [{ internalType: 'uint64', name: '', type: 'uint64' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'isInstantWithdrawalPaused',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
] as const
